import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const DowntownTrendsChart = ({ data }) => {
  const endDate = new Date('2024-08-31');

  const formatData = data
    .map((item) => ({
      date: new Date(item.date),
      med_housing: parseInt(item.med_housing) || 0,
      unemp_rate: parseFloat(item.unemp_rate) || 0,
      dh_cnt: parseInt(item.dh_cnt) || 0,
    }))
    .filter((item) => item.date <= endDate);

  const chartData = formatData.map((item) => ({
    ...item,
    date: item.date.getTime(),
  }));

  const dataLength = chartData.length;

  const desiredNumberOfTicks = 10;
  const interval = Math.max(0, Math.floor(dataLength / desiredNumberOfTicks));

  return (
    <div className="bg-white rounded-lg shadow-md p-6 border border-gray-100">
      <h3 className="text-lg font-semibold mb-4 text-gray-900">
        Downtown Homeless Population Trends
      </h3>
      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="date"
              domain={['auto', 'auto']}
              type="number"
              scale="time"
              tickFormatter={(tickItem) => {
                const date = new Date(tickItem);
                return date.toLocaleDateString('en-US', { month: 'short', year: '2-digit' });
              }}
              tick={{ fontSize: 12 }}
              interval={interval}
            />
            <YAxis
              yAxisId="left"
              tick={{ fontSize: 12 }}
              label={{
                value: 'Homeless Count',
                angle: -90,
                position: 'insideLeft',
                style: { textAnchor: 'middle' },
              }}
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              tick={{ fontSize: 12 }}
              label={{
                value: 'Median Housing Price ($)',
                angle: 90,
                position: 'insideRight',
                style: { textAnchor: 'middle' },
              }}
            />
            <Tooltip
              labelFormatter={(label) => {
                const date = new Date(label);
                return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
              }}
            />
            <Legend />
            <Line
              yAxisId="left"
              type="monotone"
              dataKey="dh_cnt"
              stroke="#2563eb"
              name="Homeless Count"
              dot={false}
            />
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="med_housing"
              stroke="#7c3aed"
              name="Median Housing Price"
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default DowntownTrendsChart;
